import React from 'react';
import { DocumentSystem } from './components/DocumentSystem';
export function App() {
  return <DocumentSystem data-id="element-0" />;
}